const SPLIT = '__'

/**
 * 点评标签与部门关联标签取交集展示
 * @param {*} sourceTree：核心指标
 * @param {*} mapTree：根据部门筛选出的指标
 */
export const getSameIndicators = (sourceTree, mapTree, level = 1) => {
  if (!sourceTree?.length || !mapTree?.length) {
    return sourceTree
  }

  const targetTree = []
  const departmentTree = mapTree.map(item => item.labelMap)
  const isLastLevel = level === Object.keys(departmentTree[0]).length

  const map = {}
  for (const source of sourceTree) {
    for (const department of departmentTree) {
      if (department[`label${level}`] === source.labelName) {
        if (source.child?.length) {
          source.child = getSameIndicators(source.child, mapTree, level + 1)
        }

        if (isLastLevel || source.child?.length) {
          if (!map[source.labelName]) {
            targetTree.push(source)
            map[source.labelName] = true
          }
        }
      }
    }
  }
  return targetTree
}

/**
 * 1. 剔除labelName = '' || labelName = 'null'的数据, 子集填补位置
 * 2. 删除重复树节点
 * 3. 增加uniqueId
 * @param {*} treeData
 * @returns
 */
export function commentTreeFormatter(treeData, parent = {}) {
  if (!treeData?.length) {
    return []
  }
  for (let i = 0; i < treeData.length; i++) {
    const item = treeData[i]
    if (item.child) {
      item.child = commentTreeFormatter(item.child, item)
    }

    if (
      !item.labelName ||
      item.labelName === 'null' ||
      (item.labelName === parent.labelName && treeData.length === 1 && item.child.length === 0)
    ) {
      // 需要删除的数据, 子节点提升
      const childList = commentTreeFormatter(item.child, item) || []
      treeData.splice(i, 1, ...childList)
      i--
      continue
    }
  }
  const func = (treeDataArray, prefix = '') => {
    for (const item of treeDataArray) {
      item.uniqueId = prefix ? prefix + SPLIT + item.labelName : item.labelName
      if (item.child?.length > 0) {
        item.child = func(item.child, item.uniqueId)
      }
    }
    return treeDataArray
  }
  return func(treeData)
}
